import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { ProfilesView } from "@/features/profiles/profiles-view";

/**
 * §M1 · `/profiles` — «Mis perfiles». Sin gate de feature: es la pantalla que
 * EXPLICA los gates, así que no puede estar detrás de uno.
 */
export const profilesRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/profiles",
  component: ProfilesView,
});
